<script>
import {Tag} from "element-ui"
export default {
  name: "assignmentStatus",
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    shopId: {
      type: [String, Number],
      default: null
    }
  },
  // eslint-disable-next-line vue/require-render-return
  render(createElement, context) {
    if (this.is_Empty(this.$props.goodsList)) return null;
    // 获取订单商品列表中的商家ID，如果有商家ID说明是已经指派了。
    let arr = this.$props.goodsList.map(el => el.order_merchants_id);
    // 判断当前订单是否为店铺订单，如果为店铺订单则不显示状态。
    if (!this.is_Empty(this.$props.shopId)) return null;
    // 2. 统计有数据的子数组数量
    const nonEmptyCount = arr.filter(subArray => this.is_Empty(subArray)).length;

    // 3. 计算总子数组数量
    const totalCount = this.$props.goodsList.length;
    let o = {text: "未指派", type: "danger"}
    // 4. 根据三种情况返回状态
    if (nonEmptyCount === totalCount) {
      o = {text: "未指派", type: "danger"}
    } else if (nonEmptyCount === 0) {
      o = {text: "已指派", type: "primary"}
    } else {
      o = {text: "部分指派", type: "warning"}
    }


    let obj = o || {text: "异常", type: "danger"};
    return createElement(Tag, {
      props: {
        type: obj.type,
        size: "small"
      }
    }, obj.text)

  }
}
</script>


<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/assignmentStatus.vue